import { createContext, useContext, useEffect, useState } from "react";
import { AddGroup } from "../components/Playoff/AddGroup";
import { AddPrizeDrawer } from "../components/Playoff/AddPrizeDrawer";
import { ToastContainer } from "react-toastify";
import { axiosInstance } from "../config/axios";

const PlayoffContext = createContext();

export const PlayoffProvider = ({ children, cart }) => {
  // console.log('cart value',cart);
  // const [products, setProducts] = useState([]);
  // const [productOpen, setProductOpen] = useState(false);
  const [allowedToCart, setAllowedToCart] = useState(cart);
  const [playoff, setPlayoff] = useState(null);
  const [isGrouped, setIsGrouped] = useState(true);
  const [groupOpen, setGroupOpen] = useState(false);
  const [prizeOpen, setPrizeOpen] = useState(false);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState(null);
  const [prize, setPrize] = useState(null);
  const [groupEdit, setGroupEdit] = useState(false);
  const [prizeEdit, setPrizeEdit] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!groupOpen) {
      setGroupEdit(false);
      setGroup(null);
    }
  }, [groupOpen]);

  const handleAddGroup = () => {
    setGroupEdit(false);
    setGroup({
      name: "",
      description: "",
      qty_limit: 1,
      products: [],
      product_category: [null],
    });
    setGroupOpen(true);
  };
  useEffect(() => {
    if (playoff) {
      setGroups(playoff.groups);
      setPrize(playoff.prize);
      setIsGrouped(playoff.grouped_list);
      setAllowedToCart(playoff.allowed_to_cart);
    }
  }, [playoff]);

  const handleEditGroup = (group_id) => {
    const group = groups.find(({ id }) => id === group_id);
    setGroup(group);
    setGroupOpen(true);
    setGroupEdit(true);
  };

  const handleAddPrize = () => {
    setPrizeOpen(true);
    setPrizeEdit(prize !== null);
  };

  // or 'edit'

  // const resetPlayoff = () => {
  // 	setPlayoffData(defaultPlayoffData);
  // 	setMode("create");
  // };

  // const loadPlayoff = (data) => {
  // 	setPlayoffData(data);
  // 	setMode("edit");
  // };
  useEffect(() => {
    console.log("====================================");
    console.log("allowedToCart ", allowedToCart);
    console.log("====================================");
  }, [allowedToCart]);

  useEffect(() => {
    const missingGroups = groups.filter((g) => !("products" in g));

    if (missingGroups.length === 0) {
      setLoading(false);
      return;
    }

    setLoading(true);

    Promise.all(
      missingGroups.map((g) =>
        axiosInstance
          .get(`group-products/${g.id}/`)
          .then((res) => ({ ...g, products: res.data }))
          .catch((err) => {
            console.error(`Failed to fetch group ${g.id}`, err);
            return g; // fallback: return group unchanged
          })
      )
    )
      .then((fetchedGroups) => {
        setGroups((prevGroups) =>
          prevGroups.map((pg) => {
            const updated = fetchedGroups.find((fg) => fg.id === pg.id);
            return updated ? updated : pg;
          })
        );
      })
      .finally(() => setLoading(false));
  }, [groups, setGroups]);

  return (
    <PlayoffContext.Provider
      value={{
        groupOpen,
        setGroupOpen,
        isGrouped,
        setIsGrouped,
        groups,
        group,
        setGroup,
        handleAddGroup,
        handleEditGroup,
        prize,
        setPrize,
        handleAddPrize,
        setGroups,
        playoff,
        setPlayoff,
        allowedToCart,
        setAllowedToCart,
        loading,
        setLoading,
        setGroupEdit,
      }}
    >
      <ToastContainer />
      {children}
      <AddGroup
        drawerOpen={groupOpen}
        setEditOpen={setGroupOpen}
        setGroups={setGroups}
        edit={groupEdit}
        group={group}
        setGroup={setGroup}
        groups={groups}
        allowedToCart={allowedToCart}
      />
      <AddPrizeDrawer
        edit={prizeEdit}
        drawerOpen={prizeOpen}
        setEditOpen={setPrizeOpen}
        prize={prize}
        setPrize={setPrize}
      />
    </PlayoffContext.Provider>
  );
};

export const usePlayoffContext = () => {
  const context = useContext(PlayoffContext);
  if (!context) {
    throw new Error("usePlayoffContext must be used inside a PlayoffProvider");
  }
  return context;
};
